import React, { Component } from 'react'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import CustomLabelEditForm from '../partials/CustomLabelEditForm'

interface Props {}

export default class CustomLabelEdit extends Component<Props> {
  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <CustomLabelEditForm />
        </ContentMain>
      </ContentLayout>
    )
  }
}
